import { Component } from '@angular/core';
import { LegalPageLayoutComponent, LegalSection } from '../../../components/legal/legal-page-layout/legal-page-layout';

@Component({
  selector: 'app-age-verification-policy',
  standalone: true,
  imports: [LegalPageLayoutComponent],
  templateUrl: './age-verification-policy.html',
})
export class AgeVerificationPolicy {
  sections: LegalSection[] = [
    { id: 'age-restriction', label: 'Age Restriction' },
    { id: 'age-verification', label: 'Age Verification' },
    { id: 'underage-user', label: 'If We Become Aware of an Underage User' },
    { id: 'underage-content', label: 'Removal of Underage Content' },
    { id: 'reporting-concerns', label: 'Reporting Concerns' },
    { id: 'creator-responsibilities', label: 'Creator Responsibilities' },
    { id: 'safeguarding-compliance', label: 'Safeguarding and Compliance' },
    { id: 'cooperation-authorities', label: 'Cooperation with Authorities' },
    { id: 'our-commitment', label: 'Our Commitment' },
  ];
}
